import Service from './Service';

export default class TaxService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/tax/';
    }


}